export default __webpack_public_path__ + "static/content-d86e0f4248cfacf9bcfa89b72d8026c8.jpg";